/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFilePowerpoint = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M5.403 10.98h-.49v1.595h.49c.357 0 .61-.06.757-.181.152-.125.228-.33.228-.617 0-.29-.076-.495-.228-.616-.147-.12-.4-.181-.757-.181z" />
        <path d="M4 2v6H1v9h3v5h16V7.586L14.414 2zm2 15h4V8H6V4h7v5h5v11H6zM16.586 7H15V5.414zm-12.71 8v-4.87h1.741c.599 0 1.05.138 1.354.415.308.276.462.687.462 1.232 0 .54-.154.952-.462 1.233-.304.277-.755.415-1.354.415h-.703V15z" />
      </g>
    </g>
  </Icon>
);
export { SvgFilePowerpoint as FilePowerpoint };
